import { isRouteErrorResponse, useRouteError } from 'react-router-dom-v6'
import { Alert, AlertDescription, AlertTitle } from '@clouway/ui'

function RouteError() {
  const error = useRouteError()

  const description = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Unexpected error.'

  return (
    <div className="p-4">
      <Alert variant="destructive">
        <AlertTitle>Something went wrong</AlertTitle>
        <AlertDescription>{description}</AlertDescription>
      </Alert>
    </div>
  )
}

export default RouteError
